import { render, staticRenderFns } from "./stepAssistance.vue?vue&type=template&id=438ee290&scoped=true&"
import script from "./stepAssistance.vue?vue&type=script&lang=ts&"
export * from "./stepAssistance.vue?vue&type=script&lang=ts&"
import style0 from "./stepAssistance.vue?vue&type=style&index=0&id=438ee290&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438ee290",
  null
  
)

export default component.exports